import floatingMenuStyles from '@/components/FloatingMenuPopup/index.module.scss'
import homeFloatingSelectStyles from '@/components/shared/homeFloatingSelect.module.scss'

export const agentSelectMenuPaperClass = `${floatingMenuStyles.paper} ${homeFloatingSelectStyles.menuPaper}`
